<template>
  <div>
    <dialog-v2
      :show="show"
      :title="title"
      max-width="550px"
      @close="$emit('close')"
      @save="save">
      <template slot="content">
        <v-layout row wrap>
          <v-flex>
            <v-text-field
              v-model="form.name"
              v-validate="'required|max:100'"
              data-vv-name="name"
              data-vv-scope="paymentPFilter"
              data-vv-as="nombre"
              :error-messages="errors.collect('paymentPFilter.name')"
              label="Nombre"
              color="black"/>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex>
            <v-text-field
              v-model="form.broken_promises"
              v-validate="'integer'"
              data-vv-name="broken_promises"
              data-vv-scope="paymentPFilter"
              data-vv-as="promesas rotas"
              :error-messages="errors.collect('paymentPFilter.broken_promises')"
              label="Promesas rotas"
              color="black"/>
          </v-flex>
        </v-layout>
        <v-subheader class="pl-0">
          Canales
        </v-subheader>
        <v-layout row wrap>
          <v-flex
            :md2="!isWhatsappOutboundActive"
            v-for="(channel, i) in filteredChannels"
            :offset-md2="!i && !isWhatsappOutboundActive"
            :key="`channel-${channel.id}`"
            class="text-xs-center">
            <v-menu 
              offset-y 
              :disabled="!canEditWhatsappWorkflow && channel.name === 'whatsapp'"
            >
              <v-btn
                icon
                slot="activator"
                @click="templateChannel = channel.name"
                :class="{ 'k-orange-linear-text': form[`send_${channel.name}`] }"
                class="channels-btn">
                <v-icon>
                  {{ channel.icon }}
                </v-icon>
              </v-btn>
              <v-list>
                <v-list-tile @click="$set(form, `send_${channel.name}`, +(!form[`send_${channel.name}`]))">
                  <v-list-tile-title>
                    {{ form[`send_${channel.name}`] ? 'Desactivar' : 'Activar' }}
                  </v-list-tile-title>
                </v-list-tile>
                <v-list-tile @click="openTemplateDialog(channel.name)">
                  <v-list-tile-title>Plantilla</v-list-tile-title>
                </v-list-tile>
                <v-list-tile
                  v-if="
                    (pFilter.template_id && pFilter[channel.name] && channel.name !== 'human') 
                    || (form.whatsapp_template_id && channel.name === 'whatsapp')
                  "
                  @click="testTemplate(channel.id)"
                >
                  <v-list-tile-title>Probar</v-list-tile-title>
                </v-list-tile>
                <v-list-tile 
                  v-if="channel.id === 2 && channel.id !== 1 && channel.id !== 10" 
                  @click="openChannelConfigDialog(channel.id)"
                >
                  <v-list-tile-title>Configuración</v-list-tile-title>
                </v-list-tile>                
              </v-list>
            </v-menu>
          </v-flex>
        </v-layout>
        <filters-list v-model="form.filters" :default-filters="form.filters" :key="filtersListKey"/>
      </template>
    </dialog-v2>
    <template-dialog
      :show="templateDialog"
      :channel="templateChannel"
      :template="template"
      :filter="form"
      :append-vars="templateVars"
      validation-scope="pTemplate"
      validation-email-scope="pCompanyEmail"
      @save="saveTemplate"
      @close="templateDialog = false" />
    <test-template-dialog
      :show="testTemplateDialog"
      :template-id="templateChannelId === 7 ? form.whatsapp_template_id || 0 : (pFilter.template || {}).id || 0"
      :channel="templateChannelId"
      validation-scope="pTestTemplate"
      @close="testTemplateDialog = false" />
    <channel-config-dialog
      v-model="form"
      v-bind="channelConfigDialog"
      @close="channelConfigDialog.show = false"
    />
    <whatsapp-templates-dialog
      :show="whatsappTemplatesDialog"
      :workflow-filter="whatsappTemplate"
      :isPaymentType="false"
      :is-in-release="false"
      :is-new-workflow="false"
      @save="saveWhatsappTemplate"
      @close="whatsappTemplatesDialog = false"
    />
  </div>
</template>

<script>
import _ from 'lodash';
import TemplateDialog from '@/components/Templates/Index';
import TestTemplateDialog from '@/components/Templates/TestDialog';
import DialogV2 from '@/components/global/DialogV2';
import FiltersList from '@/components/global/CustomerFilters/Index';
import ChannelConfigDialog from '@/components/V2CollectWorkflows/ChannelConfigDialog';
import channelsMixin from '@/mixins/channelsV2';
import filtersMixin from '@/mixins/workflowFilters';
import permissionsMixin from '@/mixins/permissions';
import EventBus from '@/event-bus';
import { validateWhatsappTemplateForWorkflow } from '@/mixins/whatsappTemplateSelect';
import WhatsappTemplatesDialog from '@/components/V2CollectWorkflows/Detail/WorkflowTree/WhatsappTemplates';

const uuidv1 = require('uuid/v1');

export default {
  inject: ['$validator'],
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    pStage: {
      type: Object,
      required: true,
    },
    pFilter: {
      type: Object,
      default() {
        return {};
      },
    },
    isWorkflowSmsConfigActive: {
      type: Boolean,
      default: false,
    },
    isWhatsappOutboundActive: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    DialogV2,
    FiltersList,
    TemplateDialog,
    TestTemplateDialog,
    ChannelConfigDialog,
    WhatsappTemplatesDialog,
  },
  mixins: [
    channelsMixin,
    filtersMixin,
    permissionsMixin,
  ],
  data() {
    const emptyForm = {
      name: '',
      broken_promises: '',
      company_email_id: null,
      whatsapp_template_id: null,
      colly_sms_template_id: null,
      colly_sms_sender_id: null,
      colly_email_template_id: null,
      colly_email_sender_id: null,
      colly_whatsapp_template_id: null,
      colly_whatsapp_sender_id: null,
      subject: '',
      send_email: 0,
      send_sms: 0,
      send_ivr: 0,
      send_human: 0,
      send_whatsapp: 0,
      email: '',
      sms: '',
      ivr: '',
      human: '',
      valid_only_sms: false,
      only_contacted_sms: false,
      filters: {
        type: 'group',
        operator: 'and',
        items: [],
      },
      sms_cs_journey: null,
      sms_check_days: null,      
      sms_owner_id: null,
      ivr_owner_id: null,
      bot_owner_id: null,
      human_owner_id: null,
      whatsapp_owner_id: null,
    };
    return {
      templateDialog: false,
      testTemplateDialog: false,
      whatsappTemplatesDialog: false,
      templateChannel: '',
      templateChannelId: 0,
      emptyForm,
      form: _.cloneDeep(emptyForm),
      filtersListKey: uuidv1(),
      channelConfigDialog: {
        show: false,
        channelId: null,
      },
    };
  },
  computed: {
    title() {
      return `${!Object.keys(this.pFilter).length ? 'Crear' : 'Editar'} filtro`;
    },
    filteredChannels() {
      const includedChannels = ['email', 'sms', 'ivr', 'human'];
      if (this.isWhatsappOutboundActive) {
        includedChannels.push('whatsapp');
      }
      return this.channels.filter(item => includedChannels.includes(item.name));
    },
    template() {
      return {
        ...this.templateChannel === 'email' && {
          company_email_id: this.form.company_email_id,
          subject: this.form.subject,
        },
        text: this.form[this.templateChannel] || '',
      };
    },
    whatsappTemplate() {
      return {
        whatsapp_template_id: this.form.whatsapp_template_id,
        colly_whatsapp_template_id: this.form.colly_whatsapp_template_id,
        colly_whatsapp_sender_id: this.form.colly_whatsapp_sender_id,
      };
    },
    canEditWhatsappWorkflow() {
      return this.checkPermissions([
        'edit_whatsapp_workflow',
      ]);
    },
  },
  methods: {
    openTemplateDialog(channel) {
      if (channel === 'whatsapp') {
        this.whatsappTemplatesDialog = true;
      } else {
        this.templateDialog = true;
      }
    },
    testTemplate(id) {
      this.templateChannelId = id;
      this.testTemplateDialog = true;
    },
    saveTemplate(form) {
      this.form = {
        ...this.form,
        ...this.templateChannel === 'email' && {
          company_email_id: form.company_email_id,
          subject: form.subject,
        },
        [this.templateChannel]: form.text,
        ...form.colly_template_id && {
          [`colly_${this.templateChannel}_template_id`]: form.colly_template_id,
          [`colly_${this.templateChannel}_sender_id`]: form.colly_sender_id,
        },
      };
    },
    saveWhatsappTemplate(form) {
      this.form.whatsapp_template_id = form.whatsapp_template_id;
      this.form.colly_whatsapp_template_id = form.colly_whatsapp_template_id;
      this.form.colly_whatsapp_sender_id = form.colly_whatsapp_sender_id;
    },
    async save() {
      const wrongChannels = this.channels.filter(item => this.form[`send_${item.name}`] && !this.form[item.name]
        && !this.form[`colly_${item.name}_template_id`] && item.name !== 'whatsapp');
      if (this.form.send_whatsapp
        && !this.form.colly_whatsapp_template_id
        && !this.form.whatsapp_template_id) {
        wrongChannels.push({
          text: 'WhatsApp',
        });
      }
      if (wrongChannels.length) {
        EventBus.$emit('modal', `Los siguientes canales no tienen texto: ${wrongChannels.map(item => item.text).join(', ')}.`);
        return;
      }
      // Las plantillas colly ya vienen filtradas por aprobadas desde la API.
      if (this.form.send_whatsapp && !this.form.colly_whatsapp_template_id) {
        const whatsappValidation = await validateWhatsappTemplateForWorkflow(
          this.axios,
          this.form.whatsapp_template_id,
        );
        if (!whatsappValidation.valid) {
          EventBus.$emit('modal', whatsappValidation.message);
          return;
        }
      }
      const activeChannels = this.channels.filter(item => this.form[`send_${item.name}`]).length !== 0;
      if (!activeChannels) {
        EventBus.$emit('modal', 'Debe activar al menos un canal');
      } else {
        // Con plantilla colly no se manda la legacy de WhatsApp, para no pisarla.
        const omitted = this.form.colly_whatsapp_template_id ? ['whatsapp_template_id'] : [];
        this.$validator.validateAll('paymentPFilter').then((validation) => {
          if (validation && !wrongChannels.length) {
            if (Object.keys(this.pFilter).length) {
              this.axios.patch(`payment_p_filters/${this.pFilter.id}`, {
                ..._.omit(this.form, ['filters', ...omitted]),
                filters: JSON.stringify(this.form.filters),
              })
                .then((response) => {
                  this.$emit('updated', response.data);
                  this.$emit('close');
                })
                .catch(() => {});
            } else {
              this.axios.post(`payment_p_stages/${this.pStage.id}/filters`, {
                ..._.omit(this.form, ['filters', ...omitted]),
                filters: JSON.stringify(this.form.filters),
              })
                .then((response) => {
                  this.$emit('created', response.data);
                  this.$emit('close');
                }).catch(() => {});
            }
          }
        });
      }
    },
    openChannelConfigDialog(channelId) {
      this.channelConfigDialog = {
        show: true,
        channelId,
      };
    },
  },
  watch: {
    show() {
      if (!Object.keys(this.pFilter).length) {
        setTimeout(() => {
          this.form = _.cloneDeep(this.emptyForm);
        }, 200);
      } else {
        this.form = {
          ..._.pick(this.pFilter, Object.keys(this.emptyForm)),
        };
      }
      if (!this.show) {
        setTimeout(() => {
          this.$validator.errors.remove('name', 'paymentPFilter');
        }, 500);
      }
      this.filtersListKey = uuidv1();
    },
  },
};
</script>

<style scoped>
.btn.channels-btn {
  width: 50px;
  height: 50px;
}
.custom-checkbox {
  width: 210px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/V2CollectWorkflows/Detail/PaymentPromiseTree/PFilterModal.vue